import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { PaypalLinkedService } from 'app/model/linkedservice/paypal.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PaypalLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                host: '*',
                clientId: '*',
                clientSecret: 'secret',
                useEncryptedEndpoints: '*',
                useHostVerification: '*',
                usePeerVerification: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class PaypalLinkedServiceAdapter extends LinkedServiceAdapter<PaypalLinkedService> {
    protected modelConstructor(): new () => PaypalLinkedService {
        return PaypalLinkedService;
    }

    protected model(): IModel {
        return PaypalLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: PaypalLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.PaypalLinkedService;
        properties.type = Metamodel.modelFor(PaypalLinkedService).name;

        properties.typeProperties = {
            host: linkedService.host,
            clientId: linkedService.clientId,
            clientSecret: passwordOrAKVtoSecretBase(linkedService.clientSecret, this.context),
            useEncryptedEndpoints: linkedService.useEncryptedEndpoints,
            useHostVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.useHostVerification : undefined,
            usePeerVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.usePeerVerification : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: PaypalLinkedService): Promise<PaypalLinkedService> {
        const properties = linkedServiceResource.properties as Model.PaypalLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.PaypalLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.host = typeProperties.host;
        linkedService.clientId = typeProperties.clientId;
        linkedService.clientSecret = secretBaseToPasswordOrAKV(typeProperties.clientSecret, true, this.context);
        linkedService.useEncryptedEndpoints = typeProperties.useEncryptedEndpoints;
        linkedService.useHostVerification = typeProperties.useHostVerification;
        linkedService.usePeerVerification = typeProperties.usePeerVerification;

        return linkedService;
    }
}
